import _ from "lodash";
import { useSelector } from "react-redux";
import * as Yup from "yup";

import LoginBackgroundType from "./LoginBackgroundType";
import SidebarCssVariable from "../../containers/Theme/SidebarCssVariable";
import GlobalUtils from "../../utils/GlobalUtils";

export const useCustomBranding = () => {
  const language = useSelector((state) => state.language);

  const append = (key, value, formData) => {
    if (!isNullOrUndefined(value)) {
      formData.append(key, value);
    }
  };

  const isNullOrUndefined = (value) => {
    return _.isNull(value) || _.isUndefined(value);
  };

  const getDefaultSideBar = () => {
    const homeSideBar = getDefaultHomeSideBar();
    const adminSideBar = getDefaultAdminSideBar();
    return {
      ...homeSideBar,
      ...adminSideBar,
      file: null,
      homeLogoPath: "",
      favIconPath: "",
      adminLogoPath: "",
    };
  };

  const getDefaultHomeSideBar = () => {
    return {
      homeSideBarColor: SidebarCssVariable.homeSideBarColorDefault,
      homeSideBarSectionFontColor:
        SidebarCssVariable.homeSideBarSectionFontColorDefault,
      homeSideBarFontColor: SidebarCssVariable.homeSideBarFontColorDefault,
      homeSideBarSelectedColor:
        SidebarCssVariable.homeSideBarSelectedColorDefault,
      homeFooterBackgroundColor:
        SidebarCssVariable.homeFooterBackgroundColorDefault,
      homeFooterButtonSelectedColor:
        SidebarCssVariable.homeFooterButtonSelectedColorDefault,
      file: null,
      homeLogoPath: "",
      customId: "",
      customType: "",
    };
  };

  const getEmptyLogoOnHeaderBar = () => {
    return {
      file: null,
      homeLogoPath: "",
    };
  };

  const getEmptyFavicon = () => {
    return {
      file5: null,
      favIconPath: "",
    };
  };

  const getDefaultAdminSideBar = () => {
    return {
      adminSideBarColor: SidebarCssVariable.adminSideBarColorDefault,
      adminSideBarSectionFontColor:
        SidebarCssVariable.adminSideBarSectionFontColorDefault,
      adminSideBarFontColor: SidebarCssVariable.adminSideBarFontColorDefault,
      adminSideBarSelectedColor:
        SidebarCssVariable.adminSideBarSelectedColorDefault,
      adminFooterBackgroundColor:
        SidebarCssVariable.adminFooterBackgroundColorDefault,
      adminFooterButtonSelectedColor:
        SidebarCssVariable.adminFooterButtonSelectedColorDefault,
      file: null,
      adminLogoPath: "",
      customId: "",
      customType: "",
    };
  };

  const getEmptyAdminLogo = () => {
    return {
      file6: null,
      adminLogoPath: "",
    };
  };

  const getDefaultEmail = () => {
    return {
      name: "",
      file4: null,
      emailLogoImgPath: "",
      headerColor: "#212851", // email color
    };
  };

  const getEmptyLogoInEmail = () => {
    let defaultEmail = getDefaultEmail();
    return {
      file4: defaultEmail.file4,
      emailLogoImgPath: defaultEmail.emailLogoImgPath,
    };
  };

  const getEmptyReportLogo = () => {
    return {
      file3: null,
      reportLogoImgPath: "",
    };
  };

  // use for Formik
  const getDefaultCustomInfo = () => {
    let defaultSideBar = getDefaultSideBar();
    return {
      name: null,
      fromEmailAddress: null,
      fromEmailAlias: null,
      emailVerificationStatus: null,
      loginTitle: null,
      baseColor: "#212851",
      loginButtonColor: "#304269",
      headerColor: "#212851", // email color
      homeLogoPath: null,
      homeSideBarColor: defaultSideBar.homeSideBarColor,
      homeSideBarSectionFontColor: defaultSideBar.homeSideBarSectionFontColor,
      homeSideBarFontColor: defaultSideBar.homeSideBarFontColor,
      homeSideBarSelectedColor: defaultSideBar.homeSideBarSelectedColor,
      homeFooterBackgroundColor: defaultSideBar.homeFooterBackgroundColor,
      homeFooterButtonSelectedColor:
        defaultSideBar.homeFooterButtonSelectedColor,
      adminLogoPath: null,
      favIconPath: null,
      adminSideBarColor: defaultSideBar.adminSideBarColor,
      adminSideBarSectionFontColor: defaultSideBar.adminSideBarSectionFontColor,
      adminSideBarFontColor: defaultSideBar.adminSideBarFontColor,
      adminSideBarSelectedColor: defaultSideBar.adminSideBarSelectedColor,
      adminFooterBackgroundColor: defaultSideBar.adminFooterBackgroundColor,
      adminFooterButtonSelectedColor:
        defaultSideBar.adminFooterButtonSelectedColor,

      loginBackgroundType: LoginBackgroundType.image,
      loginBackgroundPosition: "cover",

      // for logic
      homeLogoImgSrc: null,
      faviconImgSrc: null,
      adminLogoImgSrc: null,
      bigLogoLiveSrc: null,
      backgroundFileLiveSrc: null,
      reportLogoLiveSrc: null,
      emailLogoLiveSrc: null,
    };
  };

  const mergeDataWithValueDefault = (data) => {
    let defaultSideBar = getDefaultSideBar();

    let mergeWithDefault = {
      baseColor: data.baseColor || "#212851",
      loginButtonColor: data.loginButtonColor || "#304269",
      headerColor: data.headerColor || "#212851", // email color
      homeSideBarColor:
        data.homeSideBarColor || defaultSideBar.homeSideBarColor,
      homeSideBarSectionFontColor:
        data.homeSideBarSectionFontColor ||
        defaultSideBar.homeSideBarSectionFontColor,
      homeSideBarFontColor:
        data.homeSideBarFontColor || defaultSideBar.homeSideBarFontColor,
      homeSideBarSelectedColor:
        data.homeSideBarSelectedColor ||
        defaultSideBar.homeSideBarSelectedColor,
      homeFooterBackgroundColor:
        data.homeFooterBackgroundColor ||
        defaultSideBar.homeFooterBackgroundColor,
      homeFooterButtonSelectedColor:
        data.homeFooterButtonSelectedColor ||
        defaultSideBar.homeFooterButtonSelectedColor,
      adminSideBarColor:
        data.adminSideBarColor || defaultSideBar.adminSideBarColor,
      adminSideBarSectionFontColor:
        data.adminSideBarSectionFontColor ||
        defaultSideBar.adminSideBarSectionFontColor,
      adminSideBarFontColor:
        data.adminSideBarFontColor || defaultSideBar.adminSideBarFontColor,
      adminSideBarSelectedColor:
        data.adminSideBarSelectedColor ||
        defaultSideBar.adminSideBarSelectedColor,
      adminFooterBackgroundColor:
        data.adminFooterBackgroundColor ||
        defaultSideBar.adminFooterBackgroundColor,
      adminFooterButtonSelectedColor:
        data.adminFooterButtonSelectedColor ||
        defaultSideBar.adminFooterButtonSelectedColor,
    };

    return { ...data, ...mergeWithDefault };
  };

  const onChangeImg = (image, setSrc) => {
    // Assuming only image
    let file = image.file;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function (e) {
      setSrc([reader.result]);
    };
  };

  const validationSchema = Yup.object().shape({
    domain: Yup.string()
      .nullable(true)
      .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        language.please_enter_the_correct_url_key
      ),
    customIphoneApp: Yup.string()
      .url()
      .required(language.valid_required_key)
      .nullable()
      .notRequired(),
    customAndroidApp: Yup.string()
      .url()
      .required(language.valid_required_key)
      .nullable()
      .notRequired(),
  });

  const customValuesToFormData = (initialValues, orgData) => {
    let formData = new FormData();
    append(
      "domain",
      initialValues.domain
        ? initialValues.domain.replace(/((^\w+:|^)\/\/)?(www.)/, "")
        : initialValues.domain,
      formData
    );
    append("name", initialValues.name, formData);
    append("fromEmailAddress", initialValues.fromEmailAddress, formData);
    append("fromEmailAlias", initialValues.fromEmailAlias, formData);
    append("loginTitle", initialValues.loginTitle, formData);

    if (initialValues.file) {
      // clear old path and append new file
      append("homeLogoPath", "", formData);
      formData.append(
        "homeLogoFile",
        initialValues.file,
        initialValues.file.name
      );
    } else {
      append("homeLogoPath", initialValues.homeLogoPath, formData);
    }

    if (initialValues.file1) {
      // clear old path and append new file
      append("bigLogoIconPath", "", formData);
      formData.append(
        "bigLogoFile",
        initialValues.file1,
        initialValues.file1.name
      );
    } else {
      append("bigLogoIconPath", initialValues.bigLogoIconPath, formData);
    }

    if (initialValues.file2) {
      // clear old path and append new file
      append("loginBackgroundImgPath", "", formData);
      formData.append(
        "loginBackgroundFile",
        initialValues.file2,
        initialValues.file2.name
      );
    } else {
      append(
        "loginBackgroundImgPath",
        initialValues.loginBackgroundImgPath,
        formData
      );
    }

    if (initialValues.file3) {
      // clear old path and append new file
      append("reportLogoImgPath", "", formData);
      formData.append(
        "reportLogoFile",
        initialValues.file3,
        initialValues.file3.name
      );
    } else {
      append("reportLogoImgPath", initialValues.reportLogoImgPath, formData);
    }

    if (initialValues.file4) {
      // clear old path and append new file
      append("emailLogoImgPath", "", formData);
      formData.append(
        "emailLogoFile",
        initialValues.file4,
        initialValues.file4.name
      );
    } else {
      append("emailLogoImgPath", initialValues.emailLogoImgPath, formData);
    }

    if (initialValues.file5) {
      // clear old path and append new file
      append("favIconPath", "", formData);
      formData.append(
        "favIconFile",
        initialValues.file5,
        initialValues.file5.name
      );
    } else {
      append("favIconPath", initialValues.favIconPath, formData);
    }

    if (initialValues.file6) {
      // clear old path and append new file
      append("adminLogoPath", "", formData);
      formData.append(
        "adminLogoFile",
        initialValues.file6,
        initialValues.file6.name
      );
    } else {
      append("adminLogoPath", initialValues.adminLogoPath, formData);
    }

    let customId = null,
      customType = null;
    if (orgData && orgData.organisationType === "PARTNER" && orgData.partner) {
      customId = orgData.partner.id;
      customType = "partner";
    } else {
      customId = orgData.id;
      customType = "organisation";
    }
    append("customId", customId, formData);
    append("customType", customType, formData);
    append("headerColor", initialValues.headerColor, formData); // email color
    append("baseColor", initialValues.baseColor, formData);
    append("loginButtonColor", initialValues.loginButtonColor, formData);

    append("homeSideBarColor", initialValues.homeSideBarColor, formData);
    append(
      "homeSideBarSectionFontColor",
      initialValues.homeSideBarSectionFontColor,
      formData
    );
    append(
      "homeSideBarFontColor",
      initialValues.homeSideBarFontColor,
      formData
    );
    append(
      "homeSideBarSelectedColor",
      initialValues.homeSideBarSelectedColor,
      formData
    );
    append(
      "homeFooterBackgroundColor",
      initialValues.homeFooterBackgroundColor,
      formData
    );
    append(
      "homeFooterButtonSelectedColor",
      initialValues.homeFooterButtonSelectedColor,
      formData
    );

    append("adminSideBarColor", initialValues.adminSideBarColor, formData);
    append(
      "adminSideBarSectionFontColor",
      initialValues.adminSideBarSectionFontColor,
      formData
    );
    append(
      "adminSideBarFontColor",
      initialValues.adminSideBarFontColor,
      formData
    );
    append(
      "adminSideBarSelectedColor",
      initialValues.adminSideBarSelectedColor,
      formData
    );
    append(
      "adminFooterBackgroundColor",
      initialValues.adminFooterBackgroundColor,
      formData
    );
    append(
      "adminFooterButtonSelectedColor",
      initialValues.adminFooterButtonSelectedColor,
      formData
    );

    append("loginBackgroundType", initialValues.loginBackgroundType, formData);
    append(
      "loginBackgroundPosition",
      initialValues.loginBackgroundPosition,
      formData
    );

    append("customIphoneApp", initialValues.customIphoneApp, formData);
    append("customAndroidApp", initialValues.customAndroidApp, formData);

    if (formData.get("baseColor") === "#75b9e6") {
      formData.set("baseColor", "");
    }

    if (formData.get("loginButtonColor") === "#304269") {
      formData.set("loginButtonColor", "");
    }

    return formData;
  };

  const renderImg = (src, heightInPx, marginTopPx) => {
    return (
      <img
        style={{ height: heightInPx || "16px", width: heightInPx || "16px" }}
        src={src}
        alt=""
      ></img>
    );
  };

  const getBackgroundFileLiveSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.loginBackgroundImgPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "background",
        customInfo.loginBackgroundImgPath
      );
    }
    return src;
  };

  const getBigLogoLiveSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.bigLogoIconPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "big_logo",
        customInfo.bigLogoIconPath
      );
    }
    return src;
  };

  const getHomeLogoImgSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.homeLogoPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "logo",
        customInfo.homeLogoPath
      );
    }
    return src;
  };

  const getFaviconImgSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.favIconPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "favicon",
        customInfo.favIconPath
      );
    }
    return src;
  };

  const getAdminLogoImgSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.adminLogoPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "admin_logo",
        customInfo.adminLogoPath
      );
    }
    return src;
  };

  const getDefaultLoginPage = () => {
    return {
      loginBackgroundType: LoginBackgroundType.image,
      loginBackgroundPosition: "cover",
      baseColor: getDefaultCustomInfo().baseColor,
      loginTitle: "",
      loginButtonColor: getDefaultCustomInfo().loginButtonColor,
      file1: null,
      bigLogoIconPath: "",
      file2: null,
      loginBackgroundImgPath: "",
    };
  };

  const getEmptyLogoLoginImageMap = () => {
    let defaultLogin = getDefaultLoginPage();
    return {
      file1: defaultLogin.file1,
      bigLogoIconPath: defaultLogin.bigLogoIconPath,
    };
  };

  const getEmptyBackgroundLoginImageMap = () => {
    let defaultLogin = getDefaultLoginPage();
    return {
      file2: defaultLogin.file2,
      loginBackgroundImgPath: defaultLogin.loginBackgroundImgPath,
    };
  };

  const getReportLogoLiveSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.reportLogoImgPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "report_logo",
        customInfo.reportLogoImgPath
      );
    }
    return src;
  };

  const getEmailLogoLiveSrc = (customInfo) => {
    let src = null;
    if (
      customInfo.customType &&
      customInfo.customId &&
      customInfo.emailLogoImgPath
    ) {
      src = GlobalUtils.getFile(
        customInfo.customType,
        customInfo.customId,
        "email_logo",
        customInfo.emailLogoImgPath
      );
    }
    return src;
  };

  return {
    getDefaultCustomInfo,
    onChangeImg,
    validationSchema,
    customValuesToFormData,
    renderImg,
    getDefaultSideBar,
    getDefaultEmail,
    getBackgroundFileLiveSrc,
    getBigLogoLiveSrc,
    getDefaultLoginPage,
    getReportLogoLiveSrc,
    getEmailLogoLiveSrc,
    getEmptyLogoLoginImageMap,
    getEmptyBackgroundLoginImageMap,
    getEmptyLogoOnHeaderBar,
    getEmptyLogoInEmail,
    getEmptyReportLogo,
    getEmptyFavicon,
    getHomeLogoImgSrc,
    getFaviconImgSrc,
    getDefaultHomeSideBar,
    getAdminLogoImgSrc,
    getEmptyAdminLogo,
    getDefaultAdminSideBar,
    mergeDataWithValueDefault,
  };
};
